import React from 'react';
import { useTranslations } from '../translations/translations';
import { useLanguage } from '../contexts/LanguageContext';
import { openCookieSettings } from '../analytics/consent';

const FooterMinimal = () => {
  const currentYear = new Date().getFullYear();
  const t = useTranslations();
  const { language, localizePath } = useLanguage();

  return (
    <footer className="footer">
      <div className="container-custom">
        <div className="footer-content">
          <div>
            <div className="footer-title">{t.footer.company.title} <span style={{ fontSize: '0.85em', fontWeight: 400 }}>{t.footer.company.titleSmall}</span></div>
            <p className="footer-text">
              {t.footer.company.description}
            </p>
            <p className="footer-text" style={{ marginTop: '1.5rem', fontSize: '0.85rem', color: '#737373' }}>
              {t.footer.company.cnaps}
            </p>
          </div>

          <div>
            <div className="footer-title">{t.footer.services.title}</div>
            <ul className="footer-links">
              <li><a href="#services">{t.footer.services.cpo}</a></li>
              <li><a href="#services">{t.footer.services.risk}</a></li>
              <li><a href="#services">{t.footer.services.formation}</a></li>
              <li><a href="#services">{t.footer.services.cctv}</a></li>
            </ul>
          </div>

          <div>
            <div className="footer-title">{t.footer.contact.title}</div>
            <ul className="footer-links">
              <li>
                <strong>{t.footer.contact.paris}</strong><br/>
                30 rue Pasteur, Suresnes<br/>
                <a href="tel:+33180889587">+33 1 80 88 95 87</a><br/>
                <a href="mailto:info@altes-protection.com">info@altes-protection.com</a>
              </li>
              <li style={{ marginTop: '1.5rem' }}>
                <strong>{t.footer.contact.monaco}</strong><br/>
                Le Patio Palace, 41 Avenue Hector Otto<br/>
                <a href="tel:+33180889587">+33 1 80 88 95 87</a><br/>
                <a href="mailto:info@altes-protection.com">info@altes-protection.com</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div>
            <div>{t.footer.legal.copyright}</div>
            <div className="footer-legal-links">
              <a href={localizePath('/mentions-legales')}>{language === 'fr' ? 'Mentions légales' : 'Legal notice'}</a>
              <a href={localizePath('/confidentialite')}>{language === 'fr' ? 'Confidentialité' : 'Privacy'}</a>
              <button type="button" onClick={openCookieSettings}>{language === 'fr' ? 'Gérer les cookies' : 'Manage cookies'}</button>
            </div>
          </div>
          <img 
            src="/images/altes/logo-altes-hd-v2.png" 
            alt="ALTES" 
            className="footer-logo-small"
            style={{
              imageRendering: 'crisp-edges'
            }}
          />
        </div>
      </div>
    </footer>
  );
};

export default FooterMinimal;
